import React, { useContext, useEffect, useState } from 'react'
import { Container } from '../../base/Container';
import AppToaster from '../../commonLib/AppToaster';
import * as Yup from 'yup'
import { loadingMiniContext } from '../../commonLib/lodingMiniContext';
import { useFormik } from 'formik';
import { GetEProductionCategoryType } from '../../enumCollections/EProductionCategoryType';
import *as productCategoryCrud from '../../_crud/productCategoryCrud'
import { LoadingButton } from '../../commonLib/LoadingButton';
import { useHistory, useParams } from 'react-router-dom';
import { TextBoxTranslater } from '../../commonLib/TextBoxTranslater';

const initialValues = {
    Id: undefined,
    CatName: undefined,
    DefaultWage: 0,
    Note: undefined
}
export function EditProductCategory() {
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const [isLoadingLocal, setIsLoadingLocal] = useState(false)
    const { id } = useParams()
    const history = useHistory()

    const Schema = Yup.object().shape({
        CatName: Yup.string().min(3, "Category Name must between 3 to 50 characters").max(50, "Category Name must between 3 to 50 characters").required("Category Name is required."),
        DefaultWage: Yup.string().required("Default Wage is required.")
    })

    const formik = useFormik({
        initialValues,
        validationSchema: Schema,
        onSubmit: (values) => {
            Save(values);
        },
        onReset: (values, { resetForm }) => {
            resetForm();
        },
    });
    const Save = (value) => {
        setIsLoadingMini(true);
        setIsLoadingLocal(true);
        productCategoryCrud.Edit(value)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false);
                    setIsLoadingLocal(false);
                    AppToaster('Updated successfully.', 'success')
                    history.goBack()
                }
                else {
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false);
                    AppToaster("Server Error /Invalid Try.", 'error')
                }
            })
            .catch(error => {
                setIsLoadingMini(false);
                setIsLoadingLocal(false);
                AppToaster(error, 'error')
            })
    }
    useEffect(() => {
        getProductionCategory()
    }, []);


    function getProductionCategory() {
        setIsLoadingLocal(true);
        productCategoryCrud.GetById(id)
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        formik.setValues({
                            Id: hdata.id,
                            CatName: hdata.catName,
                            DefaultWage: hdata.defaultWage,
                            Note: hdata.note
                        })

                    }
                    else {
                        AppToaster("Server Error /Invalid Try.", 'error')
                    }
                }
                else {
                }
                setIsLoadingLocal(false);
            })
            .catch(error => {
                setIsLoadingLocal(false);
                AppToaster(error, 'error')
            })
    }

    return (
        <Container title="Edit Production Category" isBack="true">
            <form onSubmit={formik.handleSubmit} class="form-horizontal">
                <div className="row">
                    <div className="col-md-6">
                        <div class="form-group">
                            <div class="col-xs-12">
                                <label class="control-label no-padding-right">Category</label>
                                <TextBoxTranslater className="form-control" type="text" placeholder="Category Name" name="CatName" value={formik.values.CatName} onChange={(e) => formik.setValues({ ...formik.values, CatName: e.target.value })} />
                                {
                                    formik.touched.CatName &&
                                        formik.errors.CatName ? (
                                        <label className="text-danger" >
                                            {formik.errors.CatName}
                                        </label>
                                    ) : null
                                }
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div class="form-group">
                            <div class="col-xs-12">
                                <label class="control-label no-padding-right">Default Wage ₹</label>
                                <input className="form-control" type="number" placeholder="Default Wage" name="DefaultWage" {...formik.getFieldProps("DefaultWage")} />
                                {
                                    formik.touched.DefaultWage &&
                                        formik.errors.DefaultWage ? (
                                        <label className="text-danger" >
                                            {formik.errors.DefaultWage}
                                        </label>
                                    ) : null
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12">
                        <div class="form-group">
                            <div class="col-xs-12">
                                <label class="control-label no-padding-right"> Note</label>
                                <TextBoxTranslater className="form-control" type="text" placeholder="Note" name="Note" value={formik.values.Note} onChange={(e) => formik.setValues({ ...formik.values, Note: e.target.value })} />
                                {
                                    formik.touched.Note &&
                                        formik.errors.Note ? (
                                        <label className="text-danger" >
                                            {formik.errors.Note}
                                        </label>
                                    ) : null
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div class="clearfix form-actions">
                    <div class="pull-right">
                        {isLoadingLocal ?
                            <LoadingButton />
                            :
                            <button class="btn btn-info" type="submit" expand="block" disabled={!formik.isValid}>
                                <i class="ace-icon fa fa-check bigger-110"></i>
                                Update
                            </button>}
                    </div>
                </div>

            </form>
        </Container >
    )
}
